module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAVCAYAAACZm7S3AAAA4klEQVQ4T+2TMUoDURRFz50Qf0gRG4t0rsAFZAViIIUbCFiKYKuFIIKFaW2CleACkiJgyApcgCuwS2GjRfArmSsMaMZkBlzA/PL9cx68y3ui4NnUmDQ6LH1KTbf0Pp4kluuo1gt+pMVXOMI6x24jzZFvqMd7dXnP83/kTPwMA0wfaObABeKBrXiWb5DJNgmT7V3SOMTeLxolq0kzknBM7+1FIpXvqNMOB6RcA3ul4urjmYQL5nEqj8IJ0iXyDmYjg41mwliv2FelsMfBP6IOYyFXybloq8CqJfk9mLL7/c+SfAMWzHfSDHhrAwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/dataScreen/index/image/箭头@3x.png
// module id = 1011
// module chunks = 0